import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TenjinYaPage from "../pages/tenjin-ya/page";
import MangakuPage from "../pages/mangaku/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/tenjin-ya",
    element: <TenjinYaPage />,
  },
  {
    path: "/mangaku",
    element: <MangakuPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
